import {ProductsRelDocs} from "../../interfaces";
import {sendGAEventAddToCart} from "../../../../../domain/marketing/gtm-provider";
import {outbrainAddToCartEvent} from "../../../../../domain/marketing/outbrain-provider";
import {ProductDepartmentEnum} from "../../../enums/product-department-enum";
interface IProductBuyButtonProps {
    product: ProductsRelDocs,

    source?: string
}
/**
 * the entry point
 */
const StickyAddToCart = (props: IProductBuyButtonProps) => {

    const product = props.product;
    const url = `/cart?productid=${product.skuid}`;
    let addToCartText ='Add to Cart';

    if(product.isPreorder)
        addToCartText = 'Pre-Order';

    const prodExeptions = ["SBSm010SGRCK", "SBSy010SGRCK"];
    if(prodExeptions.includes(product.skuNumber)){
        addToCartText = 'Add to Cart';
    }

    let departmentID =  product.departmentID;
    const hasDataCartOpen = !product.isProductOptions && (
        departmentID === ProductDepartmentEnum.Plugins ||
        departmentID === ProductDepartmentEnum.Bundles
    );

    return (
            <>
                {
                    <div className="flex flex-wrap sticky-add-to-cart" data-cart={ hasDataCartOpen ? 'open' : undefined }>
                        <a href={url} className="w-btn text-sm lg:text-base bg-yellow-400 text-gray-700 border sticky-add-to-cart"
                           data-skunumber={product?.skuNumber}
                           onClick={ evt => {
                               sendGAEventAddToCart(
                                   product.documentName,
                                   product.skuNumber,
                                   product.skuPrice,
                                   product.documentUrlPath,
                                   'Product Add to Cart Sticky'
                               );
                               outbrainAddToCartEvent();
                           }}
                        >{addToCartText}</a>
                    </div>
                }
            </>
    )
};

export default StickyAddToCart;